module.exports = __webpack_public_path__ + "img/goTopHover2.a4fb77bc.png";